// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"af61a72c","409":"7e5f4f06"}[chunkId] + ".chunk.js";
};